<template>
  <div>

    <div class="block w-full">
      <div>
        <div class="inputTitle">
          {{ $t('plantManagment.popups.importPlants.description') }}
        </div>
        <div class="mt-5">
          <input type="file" @change="fileChanged" id="file">
        </div>
      </div>
    </div>

  </div>
</template>

<script setup>
import { useSystemStore } from "@/stores/system/SystemStore";

const systemStore = useSystemStore();

const fileChanged = (event) =>{
  systemStore.uploadedFile = event.target.files[0];
};
</script>
<style scoped>

</style>
